import { render, staticRenderFns } from "./WriteOffDetail.vue?vue&type=template&id=73466c76&scoped=true&"
import script from "./WriteOffDetail.vue?vue&type=script&lang=js&"
export * from "./WriteOffDetail.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffDetail.vue?vue&type=style&index=0&id=73466c76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73466c76",
  null
  
)

export default component.exports